import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import SideBar from "../../components/SideBar";
import { paramGenerauxMockData } from "../../utils/navbarUtils";

const AutresParametres = () => {
  const parameters = [
    {
      title: "Paramétrage de profession",
      description: "Paramétrer les professions",
      link: "/autre-parametres/professions",
      button: "Définir une nouvelle profession",
    },
    {
      title: "Paramétrage des villes",
      description: "Paramétrer les villes",
      link: "/autre-parametres/villes",
      button: "Définir une nouvelle ville",
    },
    {
      title: "Paramétrage de banques",
      description: "Paramétrer les banques",
      link: "/autre-parametres/banques",
      button: "Définir une nouvelle banque",
    },
    {
      title: "Paramétrage des types profils",
      description: "Paramétrer les différents types de profils",
      link: "/autre-parametres/type-profils",
      button: "Définir un type de profil",
    },
    {
      title: "Paramétrage des exercices",
      description: "Paramétrer les différents exercices",
      link: "/autre-parametres/exercices",
      button: "Définir un nouvel exercice",
    },
    {
      title: "Paramétrage des Produits relatifs aux attestations",
      description: "Paramétrer les différents produits",
      link: "/autre-parametres/produits-attestation",
      button: "Définir un nouveau produit",
    },
    {
      title: "Paramétrage de lieux",
      description: "Paramétrer les régions, les villes, les quartiers",
      link: "/autre-parametres/lieux",
      button: "Définir un lieu",
    },
    {
      title: "Paramétrage de la clé de répartition",
      description:
        "Paramétrer la clé de répartition des cessions aux membres du POOL",
      link: "/autre-parametres/cle-de-repartition",
      button: "Définir la clé de répartition",
    },
    {
      title: "Paramétrage des pénalités de cession",
      description:
        "Paramétrer les règles de calcul des pénalités de cession des membres au POOL",
      link: "/parametres/penalite-cession",
      button: "Définir les pénalités de cession",
    },
    {
      title: "Délai de mise en corbeille des propositions",
      description:
        "Définir le nombre de jours avant qu'une proposition non traitée soit automatiquement déplacée dans la corbeille",
      link: "/autre-parametres/delai-corbeille",
      button: "Définir la durée",
    },
    {
      title: "Autres Paramètres",
      description: "Paramétrer les autres Paramètres",
      link: "/autre-parametres/autre-parametre",
      button: "Définir un nouveau paramètre",
    },
  ];

  const [searchResults, setSearchResults] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const renderSearchResults = (results) => {
    return (
      results.map(({ category, items }) => (
        <div key={category} className="px-3 py-2">
          <h6 className="text-muted text-uppercase mb-2">
            {category}
          </h6>
          {items
            .filter((item) =>
              item.name.toLowerCase().includes(searchValue.toLowerCase())
            )
            .map((item, index) => (
              <a
                key={index}
                href={item.url}
                className="dropdown-item d-flex align-items-center gap-2 py-1"
              >
                <i className={`bx ${item.icon} text-muted`}></i>
                <span className="text-truncate">{item.name}</span>
              </a>
            ))}
        </div>
      ))
    );
  }

  useEffect(() => {
    if (searchValue && searchValue?.length > 2) {
      let results = [];
      Object.keys(paramGenerauxMockData).forEach((key) => {
        const filtered = paramGenerauxMockData[key].filter((item) =>
          item.name.toLowerCase().includes(searchValue.toLowerCase())
        );
        if (filtered.length) {
          results.push({ category: key, items: filtered });
        }
      });
      setSearchResults(results);
    }
  }, [searchValue]);

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu={"AUTRES_PARAMETRES"} />
        <div className="layout-page">
          <NavBar
            filteredResults={searchResults}
            setFilteredResults={setSearchResults}
            renderSearchResults={renderSearchResults}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row g-4">
                {parameters.map((param, index) => (
                  <div key={index} className="col-md-6 col-lg-4">
                    <div className="card h-100 shadow-sm border-0">
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title fw-bold mb-2">
                          {param.title}
                        </h5>
                        <p className="card-text flex-grow-1 text-muted">
                          {param.description}
                        </p>
                        <a href={param.link} className="btn btn-primary mt-2">
                          {param.button}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <Footer />
            <div className="content-backdrop fade"></div>
          </div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};

export default AutresParametres;
